import App from '@/App.vue';
import BrainstormClientPlugin from '@/api/brainstorm/client';
import Highcharts from 'highcharts';
import HighchartsBorderRadius from 'highcharts-border-radius';
import HighchartsNoData from 'highcharts-no-data-to-display';
import HttpClientPlugin from '@/api/client';
import LoadScript from '@/plugins/vue-plugin-load-script';
import SentinelClientPlugin from '@/api/sentinel/client';
import VueClipboard from 'vue3-clipboard';
import custifyClient from '@/plugins/custify';
import eventPipeline from '@/plugins/event-pipeline';
import i18n from '@/lang';
import initRouter from '@/router';
import useFacets from '@/nebula/facets';
import usePostDenormalize from '@/nebula/post-denormalize';
import useStoreInit from '@/store/index';
import vortex from '@/plugins/vortex';
import { createApp } from 'vue';
import { facetConfig } from '@/nebula/facet-config';
import { init } from 'shared/components/base/_base';
import { initAppMixins } from '@/plugins/app-mixins';
import { initDatadog } from '@/plugins/datadog';
import { initNebula } from '@/nebula';
import { initRecursiveComponents } from '@/plugins/recursive-components';
import { references } from '@/nebula/references';

const postDenormalizeSvc = usePostDenormalize();
const facetsSvc = useFacets(references, facetConfig);
const nebula = initNebula(postDenormalizeSvc, facetsSvc);
const store = useStoreInit({ nebula });

const router = initRouter(store);

initDatadog();
vortex.initVortex();

HighchartsBorderRadius(Highcharts);
HighchartsNoData(Highcharts);

const app = createApp(App, { postDenormalizeSvc });
app.use(store);
app.use(HttpClientPlugin, { store });
app.use(SentinelClientPlugin, { store });
app.use(BrainstormClientPlugin, { store });
app.use(LoadScript);
app.use(router);
initAppMixins(app, i18n);
init(app);
initRecursiveComponents(app);
app.use(eventPipeline);
app.use(i18n);
app.use(VueClipboard, { autoSetContainer: true, appendToBody: true });
app.use(custifyClient);
router.isReady().then(() => app.mount('#app'));
